module.exports = __webpack_public_path__ + "img/banner.c39088e0.png";